const DocumentShareConstants = {
  VIEW_MODE: 'view',
  SIGN_MODE: 'sign',
  ADD_MODE: 'add',
  EDIT_MODE: 'edit',
  SIGN_DONE_MODE: 'sign-done',
  EDIT_DONE_MODE: 'edit-done',
  VIEW_DONE_MODE: 'view-done',
  DECLINED_DONE_MODE: 'declined-done',
};

export default DocumentShareConstants;



// WEBPACK FOOTER //
// ./src-react/DocumentShare/DocumentShareConstants.jsx